export const excludeByIndex = <T>(index: number, arr: T[]): T[][] => [
  [...arr.slice(0, index)],
  [...arr.slice(index + 1)],
];
